import { sortBy } from "lodash";

import type { AudienceApiSchema } from "app/pages/benchmark-tracker/types/api.types";

export const createAudienceTableData = (
    primary: string,
    data: AudienceApiSchema,
    domainImages: Record<string, string>,
) => {
    if (!data) {
        return [];
    }

    const { primaryData, competitorsData } = data;
    const competitors = Object.keys(competitorsData);
    const {
        reach,
        reachTrend,
        periodOverPeriodReachDifference,
        yearOverYearReachDifference,
        rank,
        periodOverPeriodRankChange,
        yearOverYearRankChange,
    } = primaryData;

    const primaryTableData = {
        domain: primary,
        audienceReach: reach,
        pop: periodOverPeriodReachDifference,
        yoy: yearOverYearReachDifference,
        trends: reachTrend,
        rank: rank,
        defaultIcon: domainImages[primary],
        isPrimary: true,
        popRankChange: periodOverPeriodRankChange,
        yoyRankChange: yearOverYearRankChange,
    };

    const competitorsTableData = competitors.reduce<typeof primaryTableData[]>((acc, competitor) => {
        const data = competitorsData[competitor];
        const {
            reach,
            reachTrend,
            periodOverPeriodReachDifference,
            yearOverYearReachDifference,
            rank,
            periodOverPeriodRankChange,
            yearOverYearRankChange,
        } = data;

        return [
            ...acc,
            {
                domain: competitor,
                audienceReach: reach,
                pop: periodOverPeriodReachDifference,
                yoy: yearOverYearReachDifference,
                trends: reachTrend,
                rank: rank,
                defaultIcon: domainImages[competitor],
                isPrimary: false,
                popRankChange: periodOverPeriodRankChange,
                yoyRankChange: yearOverYearRankChange,
            },
        ];
    }, []);

    return sortBy([primaryTableData, ...competitorsTableData], "rank", "asc");
};
